import React from 'react';
import styled, { css } from 'styled-components';
import ImpContainer from '../ImpContainer/ImpContainer';
const Wrapper = styled(ImpContainer) `
  ${(props) => props.hideAbove &&
    css `
      @media (min-width: ${props.hideAbove}px) {
        display: none;
      }
    `}
  ${(props) => props.hideBelow &&
    css `
      @media (max-width: ${props.hideBelow - 1}px) {
        display: none;
      }
    `}

  ${(props) => props.fluid &&
    css `
      width: 100%;
    `}
`;
// NOTE: hideAbove is inclusive
export default function ImpHidden({ children, hideBelow, hideAbove, fluid, }) {
    if (!hideBelow && !hideAbove) {
        throw new Error('ImpHidden must have at least one of hideBelow or hideAbove');
    }
    return (React.createElement(Wrapper, { hideBelow: hideBelow, hideAbove: hideAbove, fluid: fluid }, children));
}
//# sourceMappingURL=ImpHidden.js.map